import { WorkloadTableItem } from "../../../../mst/kinds/workload.helpers";
import { TableColumn } from "../../types";

const gvcDefault = { id: "gvc", label: "GVC" };
export function WorkloadGvcColumn<TData extends WorkloadTableItem>(column: TableColumn<TData> = gvcDefault) {
  const preset: TableColumn<TData> = {
    ...gvcDefault,
    size: 190,
    enableResize: true,
    enableHide: true,
  };
  return Object.assign(preset, column);
}
